import React from "react";
import { isMobile } from "../../mobileConfig";

function DesktopZone(props) {
  return <>{isMobile() ? <></> : props.children}</>;
}

export default DesktopZone;
